import { Component, ElementRef, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core'
import { NgForm } from '@angular/forms';
// import { Cloudinary, CloudinaryImage } from '@cloudinary/url-gen';
import { BlogService } from 'src/app/services/blogs/blog.service';
import { FormService } from 'src/app/services/forms/form.service';

@Component({
    selector: 'app-news',
    templateUrl: './news.component.html',
    styleUrls: ['./news.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NewsComponent implements OnInit {
  @ViewChild ('subscribeForm') subscribeForm!: NgForm;

  showModal: boolean = false;
  overflowProperty: string = 'auto'
  blogs!: any[]
  // cloudinaryImages!: CloudinaryImage[];

  constructor(private getBlog: BlogService, private formService: FormService) { }

  ngOnInit(): void {

    this.getBlog.getBlogList().subscribe((res:any)=> {
      this.blogs = res
      console.log(this.blogs)
    })

    setTimeout(() => {
      if (this.showModal === false) {
        this.showModal = true
        document.body.style.overflow = 'hidden';

      }
    }, 3000);
  }

  
  closeModal(): void {
    this.showModal = !this.showModal;

    document.body.style.overflow = 'auto';
  }

  onSubscription(form: {
    name: string,
    email: string
  }){
    
    this.formService.postSubscriber(form).subscribe((res)=> {
      this.subscribeForm.resetForm()
    })
  }
}
